const SIZES = ["S", "M", "L", "XL", "2XL"];

export const ProductPicker = ({ items, type, onChange }) => (
  <div className="mt-4 grid grid-cols-3 gap-3">
    {items.map((it) => (
      <button key={it.id} type="button" onClick={() => onChange(it.id)} data-testid={`order-merch-button-${it.id}`}
        className={`rounded-2xl p-3 text-left text-sm transition-colors ${type === it.id ? "sticker bg-[#FFC72C]" : "border border-[#EAE3D9] bg-white hover:border-[#1E1B26]"}`}>
        <p className="font-bold leading-tight">{it.name}</p><p className="font-mono text-xs mt-1">${it.price.toFixed(2)}</p>
      </button>
    ))}
  </div>
);

export const TeeOptions = ({ colors, size, color, onSize, onColor }) => (
  <>
    <div className="mt-4 flex gap-2">{SIZES.map((s) => (
      <button key={s} type="button" onClick={() => onSize(s)} data-testid={`merch-size-${s}`}
        className={`h-10 w-12 rounded-xl text-sm font-bold border ${size === s ? "bg-[#1E1B26] text-white" : "bg-white border-[#EAE3D9]"}`}>{s}</button>))}
    </div>
    <div className="mt-4" data-testid="merch-color-picker">
      <p className="text-xs font-bold uppercase tracking-wider text-[#6E687A]">Color · <span className="text-[#1E1B26]" data-testid="merch-color-selected">{color}</span></p>
      <div className="mt-2 flex flex-wrap gap-2">
        {Object.entries(colors || {}).map(([name, hex]) => (
          <button key={name} type="button" onClick={() => onColor(name)} title={name} aria-label={name}
            data-testid={`merch-color-${name.toLowerCase().replace(/\s/g, "-")}`}
            className={`h-9 w-9 rounded-full border-2 transition-transform hover:scale-110 ${color === name ? "border-[#FF5A79] ring-2 ring-offset-2 ring-[#FF5A79]" : "border-[#EAE3D9]"}`}
            style={{ background: hex }} />
        ))}
      </div>
    </div>
  </>
);
